export const CardSwapIcon = () => {
  return (
    <svg
      width="26.32"
      height="36.68"
      viewBox="0 0 94 131"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_405_78478)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.1497 81.7692L16 99.4682L27.1944 110.385L56.5385 81.7692L27.1944 53.1539L16 64.0702L34.1497 81.7692Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.8503 41.2308L78 58.9298L66.8056 69.8462L37.4616 41.2308L66.8056 12.6154L78 23.5318L59.8503 41.2308Z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_405_78478"
          x="0"
          y="0.615387"
          width="94"
          height="129.769"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_405_78478"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_405_78478"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
